import {createPseudoPreview} from './pseudoLocalization';
import {createInstance} from 'i18next';
import {initReactI18next} from 'react-i18next';
import common from './locales/en/common.json';
import auth from './locales/en/auth.json';
import onboarding from './locales/en/onboarding.json';
import folders from './locales/en/folders.json';
import messages from './locales/en/messages.json';
import settings from './locales/en/settings.json';
import billing from './locales/en/billing.json';
import errors from './locales/en/errors.json';

import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deOnboarding from './locales/de/onboarding.json';
import deFolders from './locales/de/folders.json';
import deMessages from './locales/de/messages.json';
import deSettings from './locales/de/settings.json';
import deBilling from './locales/de/billing.json';
import deErrors from './locales/de/errors.json';

import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esOnboarding from './locales/es/onboarding.json';
import esFolders from './locales/es/folders.json';
import esMessages from './locales/es/messages.json';
import esSettings from './locales/es/settings.json';
import esBilling from './locales/es/billing.json';
import esErrors from './locales/es/errors.json';

// Bundled resources initialize synchronously, including background/native entry points.
// English remains the default; German and Spanish are explicitly selected product languages.
export const resources = {en: {common, auth, onboarding, folders, messages, settings, billing, errors},
    de: {common: deCommon, auth: deAuth, onboarding: deOnboarding, folders: deFolders, messages: deMessages, settings: deSettings, billing: deBilling, errors: deErrors},
    es: {common: esCommon, auth: esAuth, onboarding: esOnboarding, folders: esFolders, messages: esMessages, settings: esSettings, billing: esBilling, errors: esErrors}};
const i18n = createInstance();
i18n.use(initReactI18next).init({
    resources: JSON.parse(JSON.stringify(resources)),
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: Object.keys(resources),
    defaultNS: 'common',
    ns: Object.keys(resources.en),
    initAsync: false,
    showSupportNotice: false,
    keySeparator: false,
    returnNull: false,
    interpolation: {escapeValue: false, skipOnVariables: true},
    react: {useSuspense: false, bindI18n: 'languageChanged translationsUpdated'},
});

// Non-component code uses this helper; components subscribe through useTranslation.
export const t = (key, options) => i18n.t(key, options);
export default i18n;

// Module-level catalogs derived from translated copy are recomputed in dependency
// registration order before subscribed React components are notified.
const translationConstants = new Set();
export const registerTranslationRefresh = callback => { translationConstants.add(callback); };
export const refreshTranslationConstants = () => {
    pseudoPreview.refreshResources();
    for (const refresh of translationConstants) refresh();
};

// Preview is a local development tool, not a server-published language.
export const PSEUDO_PREVIEW_AVAILABLE = process.env.NODE_ENV === 'development';
const pseudoPreview = createPseudoPreview({i18n, available: PSEUDO_PREVIEW_AVAILABLE});
export const isPseudoPreviewEnabled = pseudoPreview.isEnabled;
export const setPseudoPreviewEnabled = pseudoPreview.setEnabled;
i18n.on('languageChanged', refreshTranslationConstants);
